export default __webpack_public_path__ + "static/indoor25-15757fa515100ed72c67d9d5f188799c.webp";